import { useMemo, useState } from "react";
import {
    applyAlergenosFilter,
    buildPersonasPorAlergeno,
    computeKpis,
} from "../domain/alergenosSelector";

export function useAlergenosUI({ alergenos, personas }) {
    const [q, setQ] = useState("");
    const [soloConPersonas, setSoloConPersonas] = useState(false);
    const [sortBy, setSortBy] = useState("nombre"); // "nombre" | "conteo"
    const [open, setOpen] = useState(new Set());

    const toggle = (id) =>
        setOpen((prev) => {
            const next = new Set(prev);
            next.has(id) ? next.delete(id) : next.add(id);
            return next;
        });

    const isOpen = (id) => open.has(id);

    const personasPorAlergeno = useMemo(
        () => buildPersonasPorAlergeno({ alergenos, personas }),
        [alergenos, personas]
    );

    const filtered = useMemo(
        () =>
            applyAlergenosFilter({
                alergenos,
                personasPorAlergeno,
                q,
                soloConPersonas,
                sortBy,
            }),
        [alergenos, personasPorAlergeno, q, soloConPersonas, sortBy]
    );

    const kpis = useMemo(
        () => computeKpis({ filtered, personas, personasPorAlergeno }),
        [filtered, personas, personasPorAlergeno]
    );

    const text = q.trim().toLowerCase();

    return {
        // ui state
        q,
        setQ,
        soloConPersonas,
        setSoloConPersonas,
        sortBy,
        setSortBy,

        // accordion
        toggle,
        isOpen,

        // derived
        text,
        filtered,
        personasPorAlergeno,
        kpis,
    };
}
